/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditorfullnoteplaceholder4Inputs */

const en_menueditorfullnoteplaceholder4 = /** @type {(inputs: Menueditorfullnoteplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. All prices in euros incl. VAT`)
};

const de_menueditorfullnoteplaceholder4 = /** @type {(inputs: Menueditorfullnoteplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. Alle Preise in Euro inkl. MwSt.`)
};

/**
* | output |
* | --- |
* | "e.g. All prices in euros incl. VAT" |
*
* @param {Menueditorfullnoteplaceholder4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditorfullnoteplaceholder4 = /** @type {((inputs?: Menueditorfullnoteplaceholder4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditorfullnoteplaceholder4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditorfullnoteplaceholder4(inputs)
	return de_menueditorfullnoteplaceholder4(inputs)
});
export { menueditorfullnoteplaceholder4 as "menuEditorFullNotePlaceholder" }